import { Component, Input, OnInit, computed, inject } from "@angular/core";
import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MatButton } from "@angular/material/button";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AsyncPipe } from "@angular/common";
import { MatomoTracker } from "ngx-matomo-client";
import { RedirectService } from "@e-forsyning/common/router";
import { RouterModule } from "@angular/router";
import { LocalStorage, ThemeService } from "@dffedb/util";
import { APP_SHELL_LAYOUT_OPTIONS } from "@e-forsyning/common/app-shell";

@Component({
    selector: "login-container",
    templateUrl: "./login-container.component.html",
    styleUrls: ["./login-container.component.scss"],
    imports: [MatButton, MatProgressSpinner, AsyncPipe, RouterModule]
})
export class LoginContainerComponent implements OnInit {
    @Input() public titel: string;
    @Input() public arbejder: boolean;
    @Input() public technicianLogin: boolean = false;
    public overskrift$: Observable<string>;
    private readonly layoutOptions = inject(APP_SHELL_LAYOUT_OPTIONS, { optional: true });
    private readonly themeService = inject(ThemeService);
    protected readonly loginBackgroundImageUrl = this.layoutOptions?.loginBackgroundImage ?? "/assets/images/background/back.jpg";
    private readonly loginBrandImageLight = this.layoutOptions?.loginBrandImage?.trim() || null;
    private readonly loginBrandImageDark = this.layoutOptions?.loginBrandImageDark?.trim() || null;
    protected readonly loginBrandImageUrl = computed(() => {
        if (this.themeService.activeTheme() === "dark" && this.loginBrandImageDark) {
            return this.loginBrandImageDark;
        }
        return this.loginBrandImageLight;
    });

    // Modern Angular: Use inject() function instead of constructor injection
    private readonly indstillingerObserver = inject(UmbracoIndstillingerObserver);
    private readonly matomoTracker = inject(MatomoTracker);
    private readonly redirectService = inject(RedirectService);

    public ngOnInit(): void {
        this.overskrift$ = this.indstillingerObserver.valueChanges.pipe(map((value) => value?.aktuelEforsyning?.overskriftPaaLoginside || ""));
    }

    public onSkiftForsyningClick(): void {
        this.matomoTracker.trackEvent("Login", "SkiftForsyningClick", "Skift forsyning");

        // Modern approach: Direct service call instead of parent-child communication
        this.redirectService.redirectTilVaerksListe();
    }
}
